// src/components/UI/Modal.js
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
import { FaTimes } from 'react-icons/fa'; // Icon for close button

// Backdrop component (separate for clarity)
const Backdrop = (props) => {
  return <div className={styles.backdrop} onClick={props.onClose} />;
};

// Modal overlay component (the actual modal window)
const ModalOverlay = (props) => {
  return (
    <div className={styles.modal}>
      <header className={styles.header}>
        <h2>{props.title || 'Notification'}</h2>
        <button onClick={props.onClose} className={styles.closeButton} aria-label="Close Modal">
          <FaTimes />
        </button>
      </header>
      <div className={styles.content}>
        {props.children}
      </div>
      <footer className={styles.actions}>
        {/* Add action buttons here if needed, passed via props */}
        {/* Example: <button onClick={props.onConfirm}>Confirm</button> */}
        <button onClick={props.onClose} className={styles.defaultCloseButton}>
          Close
        </button>
      </footer>
    </div>
  );
};

// Main Modal component using React Portals
const Modal = (props) => {
  // Check if running in a browser environment before accessing document
  if (typeof window === 'undefined') {
    return null; // Don't render on server or environments without document
  }

  const portalElement = document.getElementById('modal-root');

  // Ensure the portal element exists before attempting to create a portal
  if (!portalElement) {
    return null;
  }

  // Only render if show is true
  if (!props.show) {
    return null;
  }

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay
          title={props.title}
          onClose={props.onClose}
        >
          {props.children}
        </ModalOverlay>,
        portalElement
      )}
    </React.Fragment>
  );
};

export default Modal;